import { render, staticRenderFns } from "./WdfStudentPassInformation.vue?vue&type=template&id=1b06aa58"
import script from "./WdfStudentPassInformation.vue?vue&type=script&lang=js"
export * from "./WdfStudentPassInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports